<template>
  <v-app v-resize="onResize" v-if="!$store.state.loading">
    <navigation
      v-if="$store.state.app.display !=='xs' && $store.state.app.display !=='sm' && ($route.name!=='PublicAccess' &&$route.name!=='PublicLogin' && $route.name!=='PublicLoginBusiness')"
    ></navigation>
    <navigation-mobile
      v-if="($store.state.app.display ==='xs' || $store.state.app.display ==='sm')  &&  ($route.name!=='PublicAccess' &&$route.name!=='PublicLogin' && $route.name!=='PublicLoginBusiness')"
    ></navigation-mobile>

    <v-content>
      <router-view></router-view>
    </v-content>

    <contest-create></contest-create>
    <bottom-bar
      v-if="($store.state.app.display ==='xs' || $store.state.app.display ==='sm') &&  ($route.name!=='PublicAccess' &&$route.name!=='PublicLogin' && $route.name!=='PublicLoginBusiness')"
    ></bottom-bar>
    <video-player></video-player>
    <notifications></notifications>
    <newsletter></newsletter>
    <support></support>
    <terms></terms>
    <my-footer></my-footer>
  </v-app>
</template>

<script>
import myFooter from "@/components/app/footer.vue";
import navigation from "@/components/app/navigation.vue";
import bottom_bar from "@/components/app/bottom_bar.vue";
import navigation_mobile from "@/components/app/navigation_mobile.vue";
import videoPlayer from "@/components/app/video_player.vue";
import notifications from "@/components/app/notifications.vue";
import newsletter from "@/components/app/newsletter.vue";
import ContestCreate from "@/views/Business/CreateContest";
import support from "@/components/app/support.vue";
import terms from "@/components/app/terms.vue";

export default {
  name: "App",

  components: {
    navigation: navigation,
    bottomBar: bottom_bar,
    navigationMobile: navigation_mobile,
    contestCreate: ContestCreate,
    videoPlayer: videoPlayer,
    notifications: notifications,
    newsletter: newsletter,
    myFooter: myFooter,
    support: support,
    terms: terms,
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    onResize() {
      this.$store.commit("app/resized");
    },
    async load() {
      this.loading = true;

      this.loading = false;
    },
  },
  created() {
    //If we have a token in localstorage we should auto login.
    this.load();
  },
};
</script>

<style>
.blue-links a {
  color: blue;
}
p {
  margin-bottom: 0px !important;
}

.v-content__wrap {
  max-width: 100vw !important;
  width: 100vw !important;
}

.nolink {
  text-decoration: none;
}
.draggable {
  cursor: move !important;
}
.clicky {
  cursor: pointer;
}

.pb100 {
  padding-bottom: 100px;
}

.pb50 {
  padding-bottom: 50px;
}

.pt50 {
  padding-top: 50px;
}
.white-gradient {
  background: rgb(255, 255, 255);
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 1) 50%,
    rgba(174, 179, 178, 1) 100%
  );
}
.text-shadow {
  text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.5);
}
.monster {
  font-family: "Montserrat", sans-serif;
}
.raleway {
  font-family: "Raleway", sans-serif;
}
</style>
